import { useDispatch, useSelector } from "react-redux";
import { guestAccessAttempt } from "../../../features/guest/guestSlice";
import { FrameContent, FrameHeading, Text } from "./TopicsStyle";
import { TopicsData } from "./TopicsData";
import { grammar } from "../../../i18n/06_grammar"

const Topics = ({ onTopClick, isLessonUnlocked, isGuest }) => {
  const lang = useSelector(state => state.lang.lang)
  const t = grammar[lang]

  const dispatch = useDispatch()

  return (
    <FrameContent>
      <FrameHeading>{t.listOfTopics}</FrameHeading>
      {TopicsData.map((value, index) => {
        const lessonNumber = index + 1;
        const unlocked = isLessonUnlocked ? isLessonUnlocked(lessonNumber) : true;
        const handleClick = () => {
          if (isGuest) {
            dispatch(guestAccessAttempt());
            return;
          }
          if (!unlocked) return;
          onTopClick(lessonNumber);
        };

        return (
          <Text
            key={index}
            onClick={handleClick}
            data-locked={unlocked ? "false" : "true"}
          >
            <div>{lessonNumber}. {value.eng}</div>
            <div>{value.ukr}</div>
          </Text>
        );
      })}
    </FrameContent>
  );
};

export default Topics;
